import type {
  AssessmentMode,
  DynamicsEngine,
  SceneMode,
  SceneQuality,
} from './productionContracts';

export interface FeatureSwitches {
  sceneMode: SceneMode;
  dynamicsEngine: DynamicsEngine;
  assessmentMode: AssessmentMode;
  sceneQuality: SceneQuality | null;
}

export const DEFAULT_FEATURE_SWITCHES: Readonly<FeatureSwitches> = Object.freeze({
  sceneMode: 'procedural',
  dynamicsEngine: 'kinematic',
  assessmentMode: 'practice',
  sceneQuality: null,
});

/** Parse independent candidate switches. Invalid values fail safely to baseline. */
export function parseFeatureSwitches(query: URLSearchParams): FeatureSwitches {
  const scene = query.get('scene');
  const dynamics = query.get('dynamics');
  const assessment = query.get('assessment');
  const quality = query.get('quality');
  return {
    sceneMode: scene === 'textured' ? 'textured' : 'procedural',
    dynamicsEngine: dynamics === 'rapier' ? 'rapier' : 'kinematic',
    assessmentMode: assessment === 'scoring-v1' ? 'scoring-v1' : 'practice',
    sceneQuality:
      quality === 'low' || quality === 'medium' || quality === 'high' ? quality : null,
  };
}
